import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import HyroTruncateTypography from "@hyro-components/hyro-truncate-typography/HyroTruncateTypography";

export const NotificationContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "status" && prop !== "isExpanded"
})(({ status, isExpanded, theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(1.25),
  background: theme.palette.system[0],
  borderRadius: theme.shape.borderRadius,
  ...(!isExpanded && {
    cursor: "pointer",
    border: `1px solid ${status.borderColor}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    "&:hover": {
      background: theme.palette.grey[50]
    }
  })
}));

export const IconContainer = styled(Stack)(({ theme }) => ({
  width: "28px",
  height: "28px",
  alignItems: "center",
  justifyContent: "center",
  background: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius
}));

export const ContentContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  flex: 1
}));

export const StatusContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(1)
}));

export const StatusBadge = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "status"
})(({ status, theme }) => ({
  flexDirection: "row",
  paddingInline: theme.spacing(1),
  height: "22px",
  alignItems: "center",
  borderRadius: "4px",
  background: status.background,
  color: status.color
}));

export const SmallText = styled("span")(({ theme }) => ({
  color: theme.palette.text[700],
  fontSize: "10px",
  fontWeight: 400,
  lineHeight: "14px"
}));

export const PublishDescription = styled(HyroTruncateTypography)(({ theme }) => ({
  color: theme.palette.primary[800],
  fontSize: "12px",
  fontWeight: 400,
  fontStyle: "italic",
  lineHeight: "18px",
  paddingRight: "1px"
}));
